import React, { useState, useEffect, useContext, useRef } from "react";
import CompanyJob from "./CompanyJob";
import { Link } from "react-router-dom";
import { SameCompanyJobsCard } from "../Home/JobsList";
import { VerticalMode } from "../Home/AutoPlay";
import ReactHtmlParser from "react-html-parser";
import { AuthContext } from "../../context/AuthContext";
import { generateRandomString } from "../../Utility/Utility";
import moment from "moment";
import { useSnackbar } from "notistack";

// Debounce utility function
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export default function Profile(props) {
  const sameCompanyJobsSliderRef = useRef(null);
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyContact, setCompanyContact] = useState([]);
  const [companyService, setCompanyService] = useState([]);
  const [sameCompanyJobs, setSameCompanyJobs] = useState([]);
  const [companyJobs, setCompanyJobs] = useState([]);
  // const id = props.match.params.id;
  const clientslug = props.match.params.clientslug;
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    window.scrollTo(0, 0);
    axios
      .post("api/get_company_detail", { clientslug: clientslug }, { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return; //Guard skip state if unmounted
        if (res.data.status == "success") {
          setCompanyDetail(res.data.data[0]);
          setCompanyContact(res.data.companycontact);
          setCompanyService(res.data.companyservice);
          setSameCompanyJobs(res.data.samecompanyjobs);
          setCompanyJobs(res.data.companyjobs);
        } else {
          setCompanyDetail([]);
          setCompanyContact([]);
          setCompanyService([]);
          setSameCompanyJobs([]);
          setCompanyJobs([]);
        }
      })
      .catch(error => {
          if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load company details:", error);
        }
      });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [clientslug]);

  const handlePrevClick = () => {
    console.log("[VerticalSlick] Previous button clicked");
    try {
      if (!sameCompanyJobsSliderRef.current) {
        console.error("[VerticalSlick] ERROR: sameCompanyJobsSliderRef.current is null!");
        return;
      }
      sameCompanyJobsSliderRef.current.slickPrev();
    } catch (error) {
      console.error("[VerticalSlick] ERROR in handlePrevClick:", error);
    }
  };

  const handleNextClick = () => {
    console.log("[VerticalSlick] Next button clicked");
    try {
      if (!sameCompanyJobsSliderRef.current) {
        console.error("[VerticalSlick] ERROR: sameCompanyJobsSliderRef.current is null!");
        return;
      }
      sameCompanyJobsSliderRef.current.slickNext();
    } catch (error) {
      console.error("[VerticalSlick] ERROR in handleNextClick:", error);
    }
  };

  // Debounced wheel handler for same company jobs carousel
  const debouncedHandleSameCompanyJobsWheel = debounce((deltaY) => {
    console.log("[VerticalSlick] Debounced wheel handler for same company jobs triggered, deltaY:", deltaY);
    try {
      if (!sameCompanyJobsSliderRef.current) {
        console.error("[VerticalSlick] ERROR: sameCompanyJobsSliderRef.current is null!");
        return;
      }
      
      if (deltaY > 0) {
        console.log("[VerticalSlick] Scrolling DOWN - calling slickNext()");
        sameCompanyJobsSliderRef.current.slickNext();
      } else if (deltaY < 0) {
        console.log("[VerticalSlick] Scrolling UP - calling slickPrev()");
        sameCompanyJobsSliderRef.current.slickPrev();
      }
    } catch (error) {
      console.error("[VerticalSlick] ERROR in debouncedHandleSameCompanyJobsWheel:", error);
    }
  }, 300); // 300ms debounce delay

  // useEffect to attach wheel listener for same company jobs carousel
  useEffect(() => {
    const moreJobsDiv = document.querySelector('.more-jobs-carousel');
    
    if (!moreJobsDiv) {
      console.log("[VerticalSlick] more-jobs-carousel div not found");
      return;
    }

    const handleWheelWithPreventDefault = (e) => {
      console.log("[VerticalSlick] Wheel event on more-jobs-carousel div, deltaY:", e.deltaY);
      e.preventDefault(); // This now works because passive: false
      debouncedHandleSameCompanyJobsWheel(e.deltaY);
    };

    // Use addEventListener with passive: false to allow preventDefault
    moreJobsDiv.addEventListener('wheel', handleWheelWithPreventDefault, { passive: false });

    return () => {
      moreJobsDiv.removeEventListener('wheel', handleWheelWithPreventDefault);
      console.log("[VerticalSlick] Wheel event listener removed for more-jobs-carousel");
    };
  }, [debouncedHandleSameCompanyJobsWheel]);

  const getBreakpointSettings = (maxSlidesForScreen) => {
      // 1. Cap it at the maximum allowed for this screen size or total jobs
      let computedSlides = Math.min(sameCompanyJobs.length, maxSlidesForScreen) || 1;

      // 2. Apply your forced-scroll deduction rule
      if (sameCompanyJobs.length > 1 && sameCompanyJobs.length <= maxSlidesForScreen) {
        computedSlides = sameCompanyJobs.length - 1;
      }

      const shouldScroll = sameCompanyJobs.length > computedSlides;

      return {
        slidesToShow: computedSlides,
        infinite: shouldScroll,
        // autoplay: shouldScroll,
      };
    };

  const desktopSettings = getBreakpointSettings(5);

  const vsettings = {
    dots: false,
    // infinite: true,
    speed: 500,
    // slidesToShow: 3,
    slidesToScroll: 1,

    slidesToShow: desktopSettings.slidesToShow,
    infinite: desktopSettings.infinite,

    vertical: true,
    verticalSwiping: true,
    arrows: false,
    adaptiveHeight: false,
    lazyLoad: false,
    touchMove: true,
    swipeToSlide: true,
    beforeChange: (oldIndex, newIndex) => {
      console.log("[VerticalSlick] Carousel changing from index", oldIndex, "to", newIndex);
    },
    afterChange: (currentIndex) => {
      console.log("[VerticalSlick] Carousel changed to index", currentIndex);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          ...getBreakpointSettings(3),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          ...getBreakpointSettings(2),
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="section-full p-t120">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-8 col-md-12">
            <div className="company_profile">
              <div className="company_pro_banner">
                {companyDetail.coverimgUrl ? (
                  <img
                    src={companyDetail.coverimgUrl}
                    alt={companyDetail.comp_name}
                  />
                ) : (
                  <img
                    src="/default/default_company_logo.jpg"
                    alt={companyDetail.comp_name}
                  />
                )}
              </div>
              <div className="company_pro_info">
                  <div className="company_pro_img">
                    {companyDetail.imgUrl ? (
                      <img
                        src={companyDetail.imgUrl}
                        alt={companyDetail.comp_name}
                      />
                    ) : (
                      <img
                        src="/default/default_company_logo.jpg"
                        alt={companyDetail.comp_name}
                      />
                    )}
                  </div>
                  <div class="pro_name_loc">
                    {companyDetail.comp_name != "" &&
                    companyDetail.display_profile == "Y" ? (
                      <h5>
                        {companyDetail.comp_name}
                      </h5>
                    ) : (
                      ""
                    )}
                    {companyDetail.comp_address != "" &&
                    companyDetail.display_orgaddress == "Y" ? (
                      <p class="twm-job-address">
                        <i class="ri-map-pin-line"></i>{" "}
                        {companyDetail.comp_address}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
              </div>

              <div className="bg-white company_description">
                <h4>Company Description</h4>
                <div class="meta-line">
                      {companyDetail.industry != "" &&
                      companyDetail.display_industry == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-building-line"></i>
                          {companyDetail.industry}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.business != "" &&
                      companyDetail.display_orgown == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-briefcase-line"></i> {companyDetail.business}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.orgsize != "" &&
                      companyDetail.display_orgsize == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-user-2-fill"></i> {companyDetail.orgsize}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.mobile != "" &&
                      companyDetail.display_number == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-cellphone-fill"></i> {companyDetail.mobile}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.comp_phone != "" &&
                      companyDetail.display_number == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-phone-fill"></i> {companyDetail.comp_phone}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.comp_fax != "" &&
                      companyDetail.display_fax == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-message-2-fill"></i> Fax{" "}
                          {companyDetail.comp_fax}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.comp_pobox != "" &&
                      companyDetail.display_fax == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-add-box-fill"></i> P.O. Box No.{" "}
                          {companyDetail.comp_pobox}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.email != "" &&
                      companyDetail.display_email == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-mail-add-fill"></i> {companyDetail.email}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.comp_website != "" &&
                      companyDetail.display_orgwebsite == "Y" ? (
                        <a href={companyDetail.comp_website} target="_blank">
                          <span class="text-primary">
                            <i class="ri-globe-fill"></i> {companyDetail.comp_website}
                          </span>
                        </a>
                      ) : (
                        ""
                      )}
                      {companyDetail.viber != null &&
                      companyDetail.display_orgsocial == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-phone-fill"></i> {companyDetail.viber}
                        </span>
                      ) : (
                        ""
                      )}
                      {companyDetail.whatsapp != null &&
                      companyDetail.display_orgsocial == "Y" ? (
                        <span class="text-primary">
                          <i class="ri-whatsapp-fill"></i> {companyDetail.whatsapp}
                        </span>
                      ) : (
                        ""
                      )}
                </div>
                <h5>About Us</h5>
                {companyDetail.description != "" &&
                  companyDetail.display_orgsum == "Y" ? (
                    <div>{ReactHtmlParser(companyDetail.description)}</div>
                  ) : (
                    ""
                )}

                <div class="twm-social-tags">
                    {companyDetail.facebook != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a
                        href={companyDetail.facebook}
                        class="fb-clr"
                        target="_blank"
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    ) : (
                      ""
                    )}
                    {companyDetail.instagram != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a
                        href={companyDetail.instagram}
                        class="fb-clr"
                        target="_blank"
                      >
                        <i className="fa fa-instagram"></i>
                      </a>
                    ) : (
                      ""
                    )}
                    {companyDetail.linkedin != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a
                        href={companyDetail.linkedin}
                        class="link-clr"
                        target="_blank"
                      >
                        <i className="fa fa-linkedin"></i>
                      </a>
                    ) : (
                      ""
                    )}
                    {/* {companyDetail.twitter != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a
                        href={companyDetail.twitter}
                        class="tw-clr"
                        target="_blank"
                      >
                        Twitter
                      </a>
                    ) : (
                      ""
                    )} */}
                    {companyDetail.youtube != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a
                        href={companyDetail.youtube}
                        class="fb-clr"
                        target="_blank"
                      >
                        <i className="fa fa-youtube"></i>
                      </a>
                    ) : (
                      ""
                    )}
                    {/* {companyDetail.tiktok != null &&
                    companyDetail.display_orgsocial == "Y" ? (
                      <a href={companyDetail.tiktok} class="fb-clr" target="_blank">
                        <i className="fa fa-tiktok"></i>
                      </a>
                    ) : (
                      ""
                    )} */}
                    {/* <a href={companyDetail.viber} class="fb-clr" target="_blank">
                      Viber
                    </a>
                    <a
                      href={companyDetail.whatsapp}
                      class="whats-clr"
                      target="_blank"
                    >
                      Whatsapp
                    </a> */}
                  </div>
                  
              </div>
            
              {/* {companyContact.length > 0 &&
              companyDetail.display_contperson == "Y" ? (
                <div class="educational-info">
                  <h4>
                    <i class="fa fa-users">&nbsp;</i> Contact Person
                  </h4>
                  {companyContact.length > 0
                    ? companyContact.map((contact, idx) => (
                        <div class="row pb-30">
                          <div class="col-md-3">
                            <h6>Contact Person - {idx + 1}</h6>
                          </div>
                          <div class="col-md-9">
                            <h5>
                              <i class="fa fa-user">&nbsp;</i> Name:{" "}
                              {contact.full_name}
                            </h5>
                            <p>
                              <i class="fa fa-id-card">&nbsp;</i> Designation:{" "}
                              {contact.position}
                            </p>
                            <p>
                              <i class="fa fa-envelope">&nbsp;</i> Email:{" "}
                              {contact.email}
                            </p>
                            <p>
                              <i class="fa fa-phone">&nbsp;</i> Phone:{" "}
                              {contact.phone}
                            </p>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      ))
                    : ""}
                </div>
              ) : (
                ""
              )}
              {companyService.length > 0 &&
              companyDetail.display_orgservice == "Y" ? (
                <div class="educational-info">
                  <h4>
                    <i class="fa fa-cogs">&nbsp;</i> Services
                  </h4>
                  {companyService.length > 0
                    ? companyService.map((service, idx) => (
                        <div class="row pb-30">
                          <div class="col-md-3">
                            <h6>Service - {idx + 1}</h6>
                          </div>
                          <div class="col-md-9">
                            <h5>
                              <i class="fa fa-cog">&nbsp;</i>{" "}
                              {service.service_name}
                            </h5>
                            {service.service_description}
                          </div>
                          <div class="clearfix"></div>
                        </div>
                      ))
                    : ""}
                </div>
              ) : (
                ""
              )} */}

            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12">
            {/* <div className="related_jobs">
              <h4 className="twm-s-title mt-0 text-left">Company Latest Vacancies</h4>
                  
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Data Analyst (AI & SQL Specialist)</h5>
                        <h6>Rs. 200000-300000 / Monthly</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 7 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div>
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Creative Designer</h5>
                        <h6>Rs. 50000-100000 / Monthly</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 10 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div>
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>UI / UX Developer</h5>
                        <h6>Rs. 80000-130000 / Monthly</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 11 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div>
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div> 
              <div className="related-job-card">
                  <a href="#" className="related-job-card-dtl">
                      <div className="company_logo">
                        <img src="http://demo.solidfuture.com:8080/uploads/emp_img/6a0d98650eed5.png" alt="Solid Future"/>
                      </div>
                      <div className="job_ttl_com_name">
                        <h5>Digital Marketing Executive</h5>
                        <h6>Negotiable</h6>
                        <span className="sf-job-meta-item">
                          <div classname="text-clr-purple" bis_skin_checked="1">
                            <i class="fa fa-calendar-o"></i> 14 days remaining
                          </div>
                        </span>
                      </div>
                  </a>
              </div>   
                
            </div> */}

                        {sameCompanyJobs.length > 0 ? (
                            <div>
                              <div className="more-jobs-carousel">
                                <h4 className="twm-s-title mt-0 text-left">More Jobs at This Company</h4>
                                {sameCompanyJobs.length > 1 && (

                                <button
                                  onClick={handleNextClick}
                                  className="sf-relatedjobs-arrow-btn sf-arrow-left"
                                  aria-label="Previous jobs"
                                  type="button"
                                >
                                  <i className="fa fa-chevron-up"></i>
                                </button>
                                )}
                                <VerticalMode ref={sameCompanyJobsSliderRef} vsettings={vsettings}>
                                  {sameCompanyJobs.map((scj) => (
                                    <SameCompanyJobsCard key={scj.id} job={scj} />
                                  ))}
                                </VerticalMode>
                                {sameCompanyJobs.length > 1 && (
                                <button
                                  onClick={handlePrevClick}
                                  className="sf-relatedjobs-arrow-btn sf-arrow-right"
                                  aria-label="Next jobs"
                                  type="button"
                                >
                                  <i className="fa fa-chevron-down"></i>
                                </button>
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
}
